import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f3e5b6da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-menu" }
const _hoisted_2 = { class: "profile-menu__category-items" }
const _hoisted_3 = {
  key: 0,
  class: "profile-menu__category-items-item-count"
}

import { ProfileMenuItemsType, ProfileMenuItemType } from '@/types';
import { useRouter } from 'vue-router';
import { useUserStore } from '@/store/modules/user';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileMenu',
  props: {
    activeMenuItem: {},
    profileMenuItems: {}
  },
  emits: ['changeActiveMenuItem'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const changeMenuItem = (menuItem: ProfileMenuItemType) => {
  emit('changeActiveMenuItem', menuItem);
};
const router = useRouter();

const logout = async () => {
  await useUserStore().asyncLogout();
};

return (_ctx: any,_cache: any) => {
  const _component_base_divider = _resolveComponent("base-divider")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.profileMenuItems, (category, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: i,
        class: "profile-menu__category"
      }, [
        (i !== 0)
          ? (_openBlock(), _createBlock(_component_base_divider, {
              key: 0,
              class: "mt--10 mb--10"
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.filter(item => !item.hide), (menuItem) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: menuItem.id,
              to: { name: 'profile', params: { id: menuItem.id } },
              class: "items-in-line gap--10 space-between",
              onClick: ($event: any) => (changeMenuItem(menuItem))
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", {
                  class: _normalizeClass(
              _ctx.activeMenuItem?.id === menuItem.id ? 'custom-color' : 'gradient-color'
            )
                }, _toDisplayString(menuItem.title), 3),
                (menuItem.count)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(menuItem.count), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["to", "onClick"]))
          }), 128))
        ])
      ]))
    }), 128)),
    _createElementVNode("button", {
      class: "gradient-color mt--10",
      onClick: logout
    }, "Выйти")
  ]))
}
}

})